import { calcPaddingTop } from './calcPaddingTop';
var MIN_SIZE = 200;
var MAX_SIZE = 450;
if (DEVELOPMENT && location.search.includes('promo')) {
    MAX_SIZE = 350;
}
export function calcMaxGridSize() {
    var innerWidth = window.innerWidth, innerHeight = window.innerHeight;
    var paddingBottom = Math.min(MAX_SIZE, innerWidth) * 0.35;
    var min = Math.min(innerWidth, innerHeight - calcPaddingTop() - paddingBottom);
    if (min >= MAX_SIZE + 20) {
        return MAX_SIZE;
    }
    return Math.max(MIN_SIZE, min) - 20;
}
